import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-metro-icon',
  templateUrl: './metro-icon.component.html',
  standalone: false,
})
export class MetroIconComponent {
   private _svg: string = '';
  safeSvg: SafeHtml = '';

  @Input() size: string = '24';
  @Input() class: string = '';
  @Input() color: string = '';

  constructor(private sanitizer: DomSanitizer) {}

  @Input()
  set svg(value: string) {
    this._svg = value;
    this.safeSvg = this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
